/**
 * @module Reducers.CalendarPreferences
 *
 */
import { RequestError } from "typedefs";
import { CalendarPreferencesAction } from "app/actions/calendarPreferences";
import {
  CalendarPreferences,
  DEFAULT_CALENDAR_PREFERENCES,
} from "app/models/CalendarPreferences";

export interface CalendarPreferencesState {
  data: CalendarPreferences | null;
  error: RequestError | null;
  pending: boolean;
}

const initState: CalendarPreferencesState = {
  data: null,
  error: null,
  pending: false,
};

export default function calendarPreferencesReducer(
  state = initState,
  action: CalendarPreferencesAction,
): CalendarPreferencesState {
  switch (action.type) {
    case "@calendarPreferences.fetch.pending":
      return { ...state, pending: true, error: null };
    case "@calendarPreferences.fetch.success":
      return { ...state, pending: false, data: action.payload };
    case "@calendarPreferences.fetch.error":
      return { ...state, pending: false, error: action.payload };
    case "@calendarPreferences.update":
      return {
        ...state,
        data: {
          ...(state.data ?? DEFAULT_CALENDAR_PREFERENCES),
          ...action.payload,
        },
      };
    default:
      return state;
  }
}
